import { WebPlugin } from '@capacitor/core';
import { OptionsRequiredError } from './utils/errors';
export class RFIDWeb extends WebPlugin {
    async echo(options) {
        console.log('ECHO', options);
        return options;
    }
    async connect(options) {
        if (!options) {
            return Promise.reject(new OptionsRequiredError());
        }
        throw new Error("Method not implemented.");
    }
    async disconnect() {
        throw new Error("Method not implemented.");
    }
    async setOption(options) {
        if (!options) {
            return Promise.reject(new OptionsRequiredError());
        }
        throw new Error("Method not implemented.");
    }
    async startScan() {
        throw new Error("Method not implemented.");
    }
    async stopScan() {
        throw new Error("Method not implemented.");
    }
    async clear() {
        throw new Error("Method not implemented.");
    }
    async addWatcher() {
        throw new Error("Method not implemented.");
    }
    async removeWatcher() {
        throw new Error("Method not implemented.");
    }
}
//# sourceMappingURL=web.js.map